import { lazy } from 'react';

import { MonteraRoute } from 'src/utils/router';

export const HelpRoute: MonteraRoute<'help'> = {
  name: 'help',
  path: '/help',
  comp: () => lazy(() => import('./index')),
};
